import { useAuth } from "../../providers/Auth";
import { Container } from "./styles";
import { BiLogOut } from "react-icons/bi";
import { AiFillSetting } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";
import Chat from "../../components/Chat";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";

const Dashboard = () => {
  const { signOut, user, findUser } = useAuth();
  const token = localStorage.getItem("@game:accessToken") || "";
  const history = useHistory();
  const [active, setActive] = useState(false);
  const [atributes, setAtributes] = useState({} as any);

  if (!user.char) {
    history.push("/create_char");
  }

  useEffect(() => {
    findUser(user.id, token);
  }, []);

  useEffect(() => {
    setAtributes(user.char.status);
    if (atributes.points > 0) {
      setActive(true);
    }
    if (atributes.points === 0) {
      setActive(false);
    }
  }, [user, atributes]);

  const upgradeSkill = async (skill: string) => {
    await api
      .post(
        "/chars/upgrade",
        { status: skill },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        toast.success(res.data.msg);
      })
      .catch((err) => {
        toast.error(err.response.data.msg);
      });
    findUser(user.id, token);
  };
  if (!user.char) {
    return (
      <Container className="rpgui-content">
        <h1>Loading</h1>
      </Container>
    );
  }

  return (
    <Container className="rpgui-content">
      <header className="rpgui-container framed head">
        <div>
          <FaUserCircle />
          <h1>{user.username}</h1>
        </div>
        <div>
          <AiFillSetting />
          <BiLogOut onClick={signOut} />
        </div>
      </header>
      <section className="user-info">
        <div className="rpgui-container framed-golden-2 use">
          <h3>{user.char.name}</h3>
          <img src={user.char.sprite.url} alt="" />
        </div>

        <div className="rpgui-container framed-golden status">
          <h3>Status</h3>
          <p>Level: {atributes.level}</p>
          <p>HP: {atributes.hp} </p>
          <p>
            Vigor: {atributes.vigor}{" "}
            <button
              className={active ? "active-true" : "active-false"}
              onClick={() => upgradeSkill("vigor")}
            >
              +
            </button>{" "}
          </p>
          <p>
            Magic: {atributes.magic}{" "}
            <button
              className={active ? "active-true" : "active-false"}
              onClick={() => upgradeSkill("magic")}
            >
              +
            </button>{" "}
          </p>
          <p>
            Agility: {atributes.agility}{" "}
            <button
              className={active ? "active-true" : "active-false"}
              onClick={() => upgradeSkill("agility")}
            >
              +
            </button>{" "}
          </p>
          <p>
            Strength: {atributes.strength}{" "}
            <button
              className={active ? "active-true" : "active-false"}
              onClick={() => upgradeSkill("strength")}
            >
              +
            </button>{" "}
          </p>
          <p>
            Defense: {atributes.defense}{" "}
            <button
              className={active ? "active-true" : "active-false"}
              onClick={() => upgradeSkill("defense")}
            >
              +
            </button>
          </p>
          <p>Points: {atributes.points} </p>
        </div>

        <div className="rpgui-container framed-golden-2 attacks">
          <h3>Attacks</h3>
          <ul>
            {user.char.attacks.map((attack: any) => (
              <div className="rpgui-container framed">
                <p className="attack-tittle">{attack.name}</p>
                <p>type: {attack.type}</p>
                <p>power: {attack.power}</p>
                <p>hits: {attack.hits}</p>
                <p>accuracy: {attack.accuracy}</p>
              </div>
            ))}
          </ul>
        </div>
      </section>
      <section className="actions">
        <button
          className="rpgui-button golden the-battle"
          onClick={() => {
            history.push("/map");
          }}
        >
          <p>Battle!</p>
        </button>
      </section>
      <Chat />
    </Container>
  );
};

export default Dashboard;
